import { Component, OnInit, inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { RootState } from '@next/core-lib/app';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';

import { DownloadAdviceReport, DownloadManureSpaceReport } from '../../store/actions';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  standalone: false,
})
export class ReportsComponent implements OnInit {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly locale = inject(LocaleService);

  pageTitle$ = this.store.pipe(select(SiteSelectors.selectPageTitle));
  years = Array.from({ length: new Date().getFullYear() + 1 - 2020 }, (_, k) => k + 2020);

  formGroup = new FormBuilder().group({
    yearControl: [new Date().getFullYear() || '', [Validators.required]],
  });

  ngOnInit() {
    this.store.dispatch(SiteActions.updatePageTitle({ pageTitle: this.locale.translate('reports') }));
  }

  downloadAdviceReport() {
    const year = this.formGroup.controls.yearControl.value;
    if (typeof year !== 'number') {
      return;
    }
    this.store.dispatch(new DownloadAdviceReport(year));
  }

  downloadManureSpaceReport() {
    const year = this.formGroup.controls.yearControl.value;
    if (typeof year !== 'number') {
      return;
    }
    this.store.dispatch(new DownloadManureSpaceReport(year));
  }
}
